/** @file todo: review duplicate assignee input  */
import { ITooltip } from '@components/Tooltip';
import { useState } from '@hookstate/core';
import { NavigationContext } from '@layout/navigation/navigation';
import { AssetContext } from '@pages/Asset/Asset.query';
import { getPermissionData } from '@utils';
import { useContext } from 'react';
import ReactTooltip from 'react-tooltip';
import { setAttr } from '@utils/setAttr';
import { ChangeAssignee } from '../../../ChangeAssignee/ChangeAssignee';
import { Container, Avatar, Text, Empty, Line } from './Assignee.styles';

const Assignee = () => {
  const { equipmentQuery, membersQuery } = useContext(AssetContext);
  const { role } = useContext(NavigationContext);

  const open = useState(false);

  const equipment = equipmentQuery?.data;

  const assigneePermission = getPermissionData({
    action: 'assignee',
    owner: false,
    role,
    type: '',
  });
  const { allowed, message } = assigneePermission;

  if (!equipment) {
    return <div />;
  }

  const handleOpen = (e: React.SyntheticEvent) => {
    if (allowed) {
      open.set(true);
    } else {
      e.stopPropagation();
    }
  };

  return (
    <Container>
      <div
        data-tip={message}
        data-event={allowed ? undefined : 'click'}
        data-for="changeDataAssignee"
      >
        {equipment.user ? (
          <>
            {membersQuery?.data ? (
              <Line onClick={handleOpen} blocked={!allowed}>
                <Avatar
                  src={
                    membersQuery.data.find(
                      user => user.id === equipment.user?.id,
                    )?.picture
                  }
                />
                <Text blocked={!allowed}>{equipment.user.name}</Text>
              </Line>
            ) : (
              <Text onClick={handleOpen} blocked={!allowed}>
                {equipment.user.name}
              </Text>
            )}
          </>
        ) : (
          <Empty onClick={handleOpen} blocked={!allowed}>
            Empty
          </Empty>
        )}
      </div>
      <ITooltip
        id="changeDataAssignee"
        disable={setAttr(allowed)}
        afterShow={() => {
          setTimeout(ReactTooltip.hide, 1000);
        }}
      />

      <ChangeAssignee open={open} />
    </Container>
  );
};

export { Assignee };
